import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { first } from 'lodash';

@Component({
  selector: 'app-alternative-mobile-popup',
  templateUrl: './alternative-mobile-popup.component.html',
  styleUrls: ['./alternative-mobile-popup.component.scss']
})
export class AlternativeMobilePopupComponent implements OnInit {
  public isLoading: boolean = false;
  @Output() alternativeMobileNumber: EventEmitter<void> = new EventEmitter<void>();
  @Output() resendCicked: EventEmitter<void> = new EventEmitter<void>();

  public data: any;
  public alternativeMobileForm: FormGroup;
  public buttonText: string = 'GET OTP';
  public resendEnabled: boolean;
  public disableMobileNumberField: boolean = false;
  private matDialogRef: MatDialogRef<AlternativeMobilePopupComponent>;

  constructor(
    matDialogRef: MatDialogRef<AlternativeMobilePopupComponent>,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.matDialogRef = matDialogRef;
    this.data = data;
    this.resendEnabled = data.resendEnabled || false;
    this.disableMobileNumberField = data.disableMobileNumberField || false;
    this.buttonText = data.buttonText || 'GET OTP';
    this.initAlternativeMobileForm(formBuilder);
  }

  ngOnInit(): void {
  }

  private initAlternativeMobileForm(formBuilder: FormBuilder): void {
    this.alternativeMobileForm = formBuilder.group({
      mobileNumber: new FormControl(this.data.alternativeMobileNumberEntered, [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(/^[1-9]{1}[0-9]{9}$/)]),
      otp: new FormControl(null, [Validators.required, Validators.minLength(6), Validators.pattern("^[0-9]*$")])
    });
  }

  private getControlName(c: AbstractControl): string | null {
    const formGroup = c.parent.controls;
    return Object.keys(formGroup).find(name => c === formGroup[name]) || null;
  }

  public getErrorMessage(control: AbstractControl): string {
    const controlName = this.getControlName(control);
    const errors = this.allErrorMessages();
    const message = '';
    if (control.errors) {
      const occurredError = first(Object.keys(control.errors));
      const predefinedErrorsForControl = errors[controlName];
      const result = predefinedErrorsForControl.find(predefinedError => {
        return predefinedError.type === occurredError;
      });
      if (result) {
        return result.message;
      } else {
        console.log(`Could not find error message for error: ${occurredError}`);
      }
    }
    return message;
  }

  public allErrorMessages() {
    return {
      mobileNumber: [
        {
          type: 'required',
          message: 'Please enter a mobile number'
        },
        {
          type: 'minlength',
          message: `Please provide a valid mobile number`
        },
        {
          type: 'maxlength',
          message: `Please provide a valid mobile number`
        },
        {
          type: 'pattern',
          message: 'Please provide a valid mobile number'
        }
      ],
      otp: [
        {
          type: 'required',
          message: 'Please enter a OTP'
        },
        {
          type: 'pattern',
          message: `Please provide a valid OTP`
        },
        {
          type: 'minlength',
          message: `OTP should be 6 digits`
        }
      ]
    };
  }

  public onBackButtonClicked() {
    this.matDialogRef.close();
  }

  public isVerifyButtonDisabled(): boolean {
    if (this.buttonText === 'GET OTP') {
      return this.alternativeMobileForm.controls.mobileNumber.errors ? true : false;
    } else if (this.buttonText === 'VERIFY') {
      return this.alternativeMobileForm.controls.otp.errors || this.alternativeMobileForm.value.otp.length < 6 ? true : false;
    }
  }

  public onVerifyClicked() {
    if (this.buttonText === 'GET OTP') {
      this.alternativeMobileNumber.emit();
      this.isLoading = true;
    } else if (this.buttonText === 'VERIFY') {
      this.matDialogRef.close(this.alternativeMobileForm.value.otp);
    }
  }

  OnResendOtpClicked() {
    this.resendCicked.emit();
  }
}
